"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.InfoLabel = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
function InfoLabel(props) {
    var title = props.title, children = props.children, titleStyles = props.titleStyles, childStyles = props.childStyles;
    var _a = styles_1.useStyles(exports.createStyles, props), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("div", { className: classes.infoLabel },
        react_1.default.createElement("div", { className: css(classes.title, titleStyles) }, title),
        react_1.default.createElement("div", { className: css(classes.child, childStyles) }, children)));
}
exports.InfoLabel = InfoLabel;
exports.createStyles = function (theme, _a) {
    var placeholder = _a.placeholder;
    return ({
        infoLabel: {
            lineHeight: 1.5,
        },
        title: {
            fontWeight: 'bold',
        },
        child: {
            ':empty::before': {
                content: "\"" + (placeholder || '-') + "\"",
                color: theme.pallete.text.secondary,
                fontStyle: 'italic',
            },
        },
    });
};
//# sourceMappingURL=InfoLabel.js.map